import { render, staticRenderFns } from "./BusinessIntelligence.vue?vue&type=template&id=789b058a&"
import script from "./BusinessIntelligence.vue?vue&type=script&lang=js&"
export * from "./BusinessIntelligence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports